var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShareBlackMenu = function SvgShareBlackMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "fullscreen-icon",
    width: 46,
    height: 46
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55752"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55750",
    transform: "translate(-1214.865 -1019.74)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 4334",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(1214.865 1019.74)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 55751"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "noun-share-1037331",
    d: "M28.505 12.906a3.218 3.218 0 0 0-3.212 3.211 3.176 3.176 0 0 0 .186 1.061l-5.878 3.412a3.208 3.208 0 1 0 .007 4.817l5.871 3.405a3.179 3.179 0 0 0-.186 1.068 3.221 3.221 0 1 0 .617-1.885l-5.7-3.3a3.179 3.179 0 0 0 0-3.405l5.7-3.3a3.208 3.208 0 1 0 2.595-5.09Z",
    "data-fill": "a"
  })))));
};
export default SvgShareBlackMenu;